var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ShareDialog',{ref:"share",attrs:{"shareConfig":_vm.initData}},[_c('span',{staticClass:"share",staticStyle:{"display":"block"},on:{"click":function($event){return _vm.handleShare()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }